export class CommonConstant {

  public static System_Configuration = 'System Configuration'

  public static Stores = 'Stores';

  public static Catalog_Stores = 'Catalog Stores';

  public static Catalog_Details = 'Catalog Details';

  public static Store_Details = 'Store Details';

  public static Catalog = 'Catalog';

  public static User_Administration = 'User Administration';

  public static Customer_Service = 'Customer Service';

  public static Account_Settings = 'Account Settings';

  public static Shipping = 'Shipping';

  public static Open_Menu = 'Open Menu';
  public static Default_Country = 'usa';
  public static  DefaultPhoneNumberFormat = '(000) 000-0000';
  public static Default_Currency = '$';
  public static YES = 'Yes';
  public static NO = 'No';
  public static Customer_Service_Email = 'customercare@foreverliving.com';
  public static EmailSignature = 'www.foreverliving.com';
  public static AmazonSubscriptionEnabledOperatingCountries = ['USA']; //TODO : TRB-4237 Put usa as Amz subs enbled country
  public static termsAndConditionDefaultPdf = '/portals/customercare/chargebee/terms-conditions/Subscription_TermsAndConditions_en-us.pdf';
  public static Monthly = 'monthly';
  public static Yearly = 'yearly';
  public static Personal='Personal';
  public static New_FBO='New FBO';
  public static Total_Active='Total Active';
  public static Non_Manager='Non Manager';
  public static Leadership='Leadership';
  public static Monthly_Total='Monthly Total';
  public static Level='Level';
  public static four_CC_Active='4CC Active';
  public static Order_Tax='OrderTax';
  public static AS400ProfileImageURL= 'pixy.org';
  public static LOS_ANGELES_PRODUCT_CENTER = "LOS ANGELES PRODUCT CENTER"; 
  public static RECOGNITION= 'Recognition';
}

export class DownlineMemberLevel{
  public static ASSISTANT_SUPERVISOR = 'Assistant Supervisor' ;
  public static SUPERVISOR = 'Supervisor' ;
  public static ASSISTANT_MANAGER = 'Assistant Manager' ;
  public static NOVUS_CUSTOMER = 'Novus Customer' ;
}




// WEBPACK FOOTER //
// ./src/app/shared/constants/common.constants.ts